import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent, NotificationsBaseComponent } from './notifications.component';
import { DescriptiveNotificationComponent } from './descriptive-notification/descriptive-notification.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NotificationsComponent, NotificationsBaseComponent, DescriptiveNotificationComponent],
})
export class NotificationsModule {}
